import React from 'react';
import { SEO } from '../components/seo/SEO';
import { Contact } from '../components/sections/Contact';
import styles from './ContactPage.module.css';

export const ContactPage: React.FC = () => {
    return (
        <div className={styles.page}>
            <SEO
                title="Contact"
                description="Get in touch with Integrova AI for a free consultation on your digital transformation, AI, or SAP projects."
                canonical="/contact"
            />
            <Contact />
        </div>
    );
};
